import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

const LABEL_SPACING_Y = 8;

export const StyledDropdownLabel = styled.span.attrs<{ "data-automation"?: string }>(() => ({
    "data-automation": "dropdown-label-text",
}))`
    ${setFontVariant("h4", colorsPalettes.carbon["400"])};

    font-weight: 400;
    white-space: nowrap;
    user-select: none;
`;

export const StyledDropdownLabelWrapped = styled(StyledDropdownLabel)`
    margin-right: ${LABEL_SPACING_Y}px;
    white-space: normal;
`;

export const StyledDropdownLabelGapWrapped = styled(StyledDropdownLabelWrapped)`
    line-height: 40px;
`;

export const StyledLabelWrapper = styled(LeftFlexRow)`
    align-items: baseline;
    min-width: 0;

    ${StyledDropdownLabel} {
        margin-right: ${LABEL_SPACING_Y}px;
    }
`;
